import React from 'react';
import { IconButton } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import useThemeMode from '../hooks/useThemeMode';

function ThemeToggleButton({ sx }) {
  const { mode, toggleMode } = useThemeMode();
  return (
    <IconButton
      onClick={toggleMode}
      aria-label="Toggle dark mode"
      title="Toggle dark mode"
      color="inherit"
      sx={sx}
    >
      {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
    </IconButton>
  );
}

export default ThemeToggleButton;
